import type { LayerProps } from 'react-map-gl';

// Capa principal: círculo por sección
// - Tamaño proporcional al total de votantes
// - Color según % de confirmación (rojo → amarillo → verde)
export const sectionLayer: LayerProps = {
  id: 'sections',
  type: 'circle',
  paint: {
    'circle-radius': [
      'interpolate', ['linear'], ['get', 'total'],
      0,   10,
      20,  16,
      50,  22,
      100, 30
    ],
    'circle-color': [
      'interpolate', ['linear'], ['get', 'porcentaje'],
      0,   '#ef4444',
      30,  '#f59e0b',
      60,  '#84cc16',
      100, '#22c55e'
    ],
    'circle-stroke-width': 2,
    'circle-stroke-color': '#ffffff',
    'circle-opacity': 0.88
  }
};

// Etiqueta con número de sección encima del círculo
export const sectionLabelLayer: LayerProps = {
  id: 'section-labels',
  type: 'symbol',
  layout: {
    'text-field': ['get', 'seccion'],
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 11,
    'text-anchor': 'center',
  },
  paint: {
    'text-color': '#ffffff',
    'text-halo-color': 'rgba(0,0,0,0.6)',
    'text-halo-width': 1
  }
};

// Alias para compatibilidad con imports existentes
export const clusterLayer = sectionLayer;
export const clusterCountLayer = sectionLabelLayer;
export const clusterLabelLayer = sectionLabelLayer;
export const unclusteredPointLayer = sectionLayer;
